"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const React = require("react");
const react_native_1 = require("react-native");
const theme_1 = require("../modules/theme");
const test_1 = require("../modules/test");
const theme = (0, theme_1.getTheme)();
class Text extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const { bold, color, size, flex, align } = this.props;
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                text: {
                    color,
                    flex,
                    fontSize: size,
                    textAlign: align,
                    fontFamily: bold ? theme.fontFamily1 : theme.fontFamily2
                }
            });
            return styles;
        };
    }
    render() {
        const { style, children, nativeID } = this.props;
        const textStyle = this.getStyles();
        return (React.createElement(react_native_1.Text, { nativeID: nativeID, testID: (0, test_1.getTestID)(nativeID), style: [textStyle.text, style] }, children));
    }
}
exports.Text = Text;
Text.defaultProps = {
    bold: false,
    size: 14,
    color: theme.textColor1
};
